export default __webpack_public_path__ + "static/media/poweredByAltoTech.6349112e.svg";